export default (day, month, year) => {
  const response = {};
  response.day = `${day}`.padStart(2, "0");
  response.month = `${month}`.padStart(2, "0");
  response.year = `${year}`;
  return response;
};
